import { render, staticRenderFns } from "./FollowAccount.vue?vue&type=template&id=e8a87350&scoped=true"
import script from "./FollowAccount.vue?vue&type=script&lang=js"
export * from "./FollowAccount.vue?vue&type=script&lang=js"
import style0 from "./FollowAccount.vue?vue&type=style&index=0&id=e8a87350&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8a87350",
  null
  
)

export default component.exports